<template lang="pug">
	.display-text(v-if="showed")
		.modal(:tabindex="-1" :role="'dialog'" :style="{'display': 'block'}")
			.modal-dialog.modal-dialog-centered(:role ="'document'")
				.modal-content
					//.modal-header
						h5.modal-title Airbraker Filtered IPs
					.modal-body
						.form-group
							textarea.form-control(v-model="dataToDisplay")
					.modal-footer
						button.btn.btn-primary(type="button" v-on:click="copy") Copy
						button.btn.btn-dark(type="button" v-on:click="close") Close

</template>
<script>
	import Screen 				from './../../mixins/screen';

	export default {
		name: 'DisplayText',
		mixins: [Screen],
		screen: {
			events: {
				// "Airbraker Filtered IPs Received": function (ips) {
				//
				// 	this.received = true;
				// 	this.newIPs = ips.join('\n');
				//
				// }
			},
			updateOn: [],
			showed: false
		},
		data() {
			return {
				dataToDisplay: ''
			}
		},
		methods: {
			collectData(action, data) {
				this.dataToDisplay = data;
				this.$nextTick(() => {
					let textArea = document.querySelector('.display-text > .modal textarea');
					if (textArea) textArea.setAttribute('rows', Math.min(data.split(/\r\n|\r|\n/).length + 1, 30));
				});
			},
			close() {
				this.hide();
			},
			copy() {
				navigator.clipboard.writeText(this.dataToDisplay);
			}
		}

	}
</script>
<style lang="sass">

	.display-text
		position: absolute
		z-index: 2000
		left: 0
		top: 0
		right: 0
		bottom: 0
		background-color: rgba(0, 0, 0, 0.6)

		.modal-dialog
			max-width: 600px

		.modal-content
			border: none
			background: none

			.modal-header
				background-color: #343b41
				border-bottom: 1px solid #23282c
				color: #e4e7ea

			.modal-body
				background-color: #3a4149

				textarea
					background-color: #3a4149
					border-color: #c8ced3
					white-space: nowrap
					font-size: 12px
					color: white

				::-webkit-resizer
					display: none

				::-webkit-scrollbar
					width: 10px
					height: 10px
					margin-left: -10px
					-webkit-appearance: none
					appearance: none

				::-webkit-scrollbar-thumb
					height: 50px
					background-color: rgba(255,255,255,0.2)
					background-clip: content-box
					border-color: transparent
					border-style: solid
					border-width: 1px 2px
					border-radius: 5px

			.modal-footer
				background-color: #3a4149
				border: none
				justify-content: space-between


</style>
